module.exports = __webpack_public_path__ + "static/media/escape_room.e73df23a.png";